// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    ACCOUNTS_PROMILES_REQUEST_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    accountsPromilesRequestResult,
} from 'Redux/actions';

// Helpers
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* promilesRequest({ payload }) {
    try {

        let QUERY = `
            mutation promilesRequest ($dateRange: AWSDateTimeRange, $companyIds: [Int]!) {
                result: promilesRequest (dateRange: $dateRange, companyIds: $companyIds)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(accountsPromilesRequestResult({ data: data?.result }))
        } else yield put(accountsPromilesRequestResult({ error: true }))

    } catch (exc) {
        yield put(accountsPromilesRequestResult({ error: true }))
        ExceptionManager(exc, 'Modules/accounts/views/components/promilesRequest/redux/saga', 'promilesRequest');
    }
}
function* watchMethods() {
    yield takeEvery(ACCOUNTS_PROMILES_REQUEST_REQUEST, promilesRequest);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}